export const outfit = {
  id: '645628-1171938-1367952-1649736',
  items: [
    {
      label: null,
      laydown: {
        maxHeight: 0.39,
        maxWidth: 0.3,
        x: 0.33,
        y: 0.54,
        xAnchor: 'center',
        yAnchor: 'bottom',
      },
      shopProductVariant: {
        id: '1218390',
        image: {
          altText: 'Josey Elbow Patch Sweater - Off-White - Flat Front',
          baseUrl:
            'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
          mediaPath: '/v1566422191/a8otikprlka7nqmsci6h.jpg',
          medium:
            'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim:9/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1566422191/a8otikprlka7nqmsci6h.jpg',
          small:
            'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1566422191/a8otikprlka7nqmsci6h.jpg',
          __typename: 'ShopMedia',
        },
        sku: '1218390',
        url: 'https://www.stitchfix.com/product/LETY-ME-Josey-Elbow-Patch-Sweater/D47XLZ53W?sku-id=1218390&color=Off-White&size=S',
      },
      __typename: 'OutfitItem',
    },
    {
      label: null,
      laydown: {
        maxHeight: 0.73,
        maxWidth: 0.23,
        x: 0.57,
        y: 0.5,
        xAnchor: 'left',
        yAnchor: 'center',
      },
      shopProductVariant: {
        id: '1198072',
        image: {
          altText: 'Lynn Mid Rise Bootcut Jean - Indigo - Flat Front',
          baseUrl:
            'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
          mediaPath: '/v1568999371/m77t8tniizqk43lvatei.jpg',
          medium:
            'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim:9/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1568999371/m77t8tniizqk43lvatei.jpg',
          small:
            'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1568999371/m77t8tniizqk43lvatei.jpg',
          __typename: 'ShopMedia',
        },
        sku: '1198072',
        url: 'https://www.stitchfix.com/product/Judy-Blue-Lynn-Mid-Rise-Bootcut-Jean/ZDPZQLLRP?sku-id=1198072&color=Indigo&size=2&inseam=32',
      },
      __typename: 'OutfitItem',
    },
    {
      label: null,
      laydown: {
        maxHeight: 0.32,
        maxWidth: 0.2,
        x: 0.33,
        y: 0.64,
        xAnchor: 'center',
        yAnchor: 'top',
      },
      shopProductVariant: {
        id: '134114',
        image: {
          altText: 'Sutro Open Knit Infinity Scarf - Mustard - Flat Front',
          baseUrl:
            'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
          mediaPath: '/v1526404623/yvon76zd4ys9fevoluf6.jpg',
          medium:
            'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim:9/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1526404623/yvon76zd4ys9fevoluf6.jpg',
          small:
            'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1526404623/yvon76zd4ys9fevoluf6.jpg',
          __typename: 'ShopMedia',
        },
        sku: '134114',
        url: 'https://www.stitchfix.com/product/Octavia-Sutro-Open-Knit-Infinity-Scarf/V7P8G4MVP?sku-id=134114&color=Mustard&size=One-Size',
      },
      __typename: 'OutfitItem',
    },
  ],
};

export const media = [
  {
    altText: 'Kaylee Skinny Colored Jean - Olive - Figure Front',
    category: 'figure_front',
    contentType: 'IMAGE',
    group: 'figure_image',
    label: 'figure_front',
    modelSize: {
      height: '70',
      waist: null,
      dress: '4',
      alphaSizeName: 'S',
      __typename: 'MediaModel',
    },
    originalSrc:
      'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1649889157/lkudhvveqdd0epqzpw5u.jpg',
    position: 0,
    __typename: 'ShopMedia',
  },
  {
    altText: 'Kaylee Skinny Colored Jean - Olive - Figure Back',
    category: 'figure_back',
    contentType: 'IMAGE',
    group: 'figure_image',
    label: 'figure_back',
    modelSize: {
      height: '70',
      waist: null,
      dress: '4',
      alphaSizeName: 'S',
      __typename: 'MediaModel',
    },
    originalSrc:
      'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1649889233/gz3aumn2pe4exvpmxn0g.jpg',
    position: 1,
    __typename: 'ShopMedia',
  },
  {
    altText: 'Kaylee Skinny Colored Jean - Olive - Figure Detail',
    category: 'figure_detail',
    contentType: 'IMAGE',
    group: 'figure_image',
    label: 'figure_detail',
    modelSize: {
      height: '70',
      waist: null,
      dress: '4',
      alphaSizeName: 'S',
      __typename: 'MediaModel',
    },
    originalSrc:
      'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1649889250/wfynsp4gqa0ztyivlxxw.jpg',
    position: 2,
    __typename: 'ShopMedia',
  },
  {
    altText: 'Kaylee Skinny Colored Jean - Olive - Flat Front',
    category: 'flat_front',
    contentType: 'IMAGE',
    group: 'flat_image',
    label: 'flat_front',
    modelSize: null,
    originalSrc:
      'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1596842143/ffsp0jrsrv9jvqg1zorm.jpg',
    position: 3,
    __typename: 'ShopMedia',
  },
  {
    altText: 'Kaylee Skinny Colored Jean - Olive - Style Card',
    category: 'style_card',
    contentType: 'IMAGE',
    group: 'style_card',
    label: 'style_card',
    modelSize: null,
    originalSrc:
      'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1597091955/p9xvtqnlq5amgoodjl4m.jpg',
    position: 4,
    __typename: 'ShopMedia',
  },
];

/**
 * `flat_detail` is not in `media` (avoids a noisy snapshot change on the full gallery);
 * it is used alone in tests for Pager `main` horizontalAlignment + objectFit mapping.
 */
export const flatDetailImage = {
  altText: 'Kaylee Skinny Colored Jean - Olive - Flat Detail',
  category: 'flat_detail',
  contentType: 'IMAGE',
  group: 'flat_image',
  label: 'flat_detail',
  modelSize: null,
  originalSrc:
    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1596842143/ffsp0jrsrv9jvqg1zorm.jpg',
  position: 3,
  __typename: 'ShopMedia',
};
